import { render } from "./ProductReviews.vue?vue&type=template&id=4206a708&scoped=true"
import script from "./ProductReviews.vue?vue&type=script&lang=js"
export * from "./ProductReviews.vue?vue&type=script&lang=js"

import "./ProductReviews.vue?vue&type=style&index=0&id=4206a708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4206a708"]])

export default __exports__